import headerNavContent from './headerNavContent';
import discussionContent from './discussionContent';
import personPageContent from './personPageContent';
import flagContent from './flagContent';
import indexPageContent from './indexPageContent';
import composerContent from './composerContent';
import signContent from './signContent';

/**
 * 扩展管理
 */
export default function extensionsManage () {
  headerNavContent();
  indexPageContent();
  discussionContent();
  signContent();
  personPageContent();
  flagContent();
  composerContent();
}
